import React from 'react'
import { Container, Row, Col} from 'react-bootstrap'
// Asset Imports
import '../../assets/css/stylesheets/pages/Pricing/PricingPlans.css'
import PriceCard from '../../components/card/PriceCard'

function PricingPlans() {
    return (
        <Container className='pricingplans-container'>
            <Row>
                <Col>
                    <div className='pricingplans-container-header slide-in-left'>
                        <h1>Find the advertising plan that's right for you.</h1>
                        <p>
                            Jersey Directory is an all in one advertising tool that pays for itself with just one sale and never stops working for the next year.                            
                        </p>
                        <p>
                            From online publication to a custom tailored website we have plans to meet your needs.
                        </p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <PriceCard
                        planName='Breeder Listing'
                        price='$50'
                        frequency='Per listing/annually'
                        description='Breeder Directory Listing with the following'
                        planCode='P'
                        benefits={[
                            '24/7 Online Publication and Hosting',
                            'Farm Name',
                            'Address',
                            'Phone Number',
                            'Email Address',
                            'Herd Size',
                            'Performance Programs',
                            'Farm Logo',
                            'Farm Message - $1 per Word'
                        ]} />
                </Col>
                <Col>
                    <PriceCard
                        planName='Industry Listing'
                        price='$75'
                        frequency='Per listing/annually'
                        description='Industry Directory Listing with the following'
                        planCode='P'
                        benefits={[
                            '24/7 Online Publication and Hosting',
                            'Business Name',
                            'Address',
                            'Phone Number',
                            'Email Address',
                            'Herd Size',
                            'Performance Programs',
                            'Farm Logo',
                            'Farm Message - $1 per Word'
                        ]} />
                </Col>                
            </Row>
        </Container>
    )
}

export default PricingPlans